import CardsList from "@/components/cardsList";
import { LBGhoverEffect } from "styles/hoverPresets";
import { FEATURES_CONSTANTS } from "./constants";

const FeaturesComp = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 3 }}
      list={FEATURES_CONSTANTS}
      hoverEffect
      hover={LBGhoverEffect}
    />
  );
};

export default FeaturesComp;
